import { Pipe, PipeTransform } from '@angular/core';

import { Account, AccountStatus } from '@personal-area/global/accounts/models';

import { AccountType } from '../models/account-type';

export function getAccountType(account: Account): AccountType {
  return [AccountStatus.archived, AccountStatus.restoring].includes(account.status)
    ? 'archived'
    : account.isBonus && account.status === AccountStatus.active
      ? 'promo'
      : account.isDemo && !account.isBonus && account.status === AccountStatus.active
        ? 'demo'
        : 'real';
}

@Pipe({
  name: 'accountType',
  standalone: true,
})
export class AccountTypePipe implements PipeTransform {
  transform(account: Account): AccountType {
    return getAccountType(account);
  }
}
